export default "__VITE_ASSET__800df4a1__"